"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _i18n = _interopRequireDefault(require("../../util/i18n.js"));
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _functions = require("../../util/functions");
require("./MorningstarWidget.css");
var _underscore = require("underscore");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faStar);
const LOCALE_LOOKUP = {
  'US': 'en-US',
  'GB': 'en-GB',
  'EU': 'en-GB'
};
const NA = 'N/A';
function MorningstarWidget(props) {
  const {
    dataspanApiUrl,
    ticker,
    wtRegion,
    showMorningstarAll
  } = props;

  // FundData
  const [fundData, setFundData] = (0, _react.useState)(null);

  // Modal state
  const [showInfo, setShowInfo] = (0, _react.useState)(false);

  // Set up Module details
  (0, _react.useEffect)(() => {
    if (!fundData) {
      // Load the batches on first load
      getFundData();
    }
  });

  // Get the Fund Data for the app
  const getFundData = async () => {
    const params = {
      ticker: ticker
    };
    const request = {
      method: 'GET',
      url: "".concat(dataspanApiUrl, "/funddetails/morningstar/"),
      headers: {
        'Content-Type': 'application/json'
      },
      params: params
    };
    try {
      // Get the fund data from dataspan
      const response = await (0, _axios.default)(request);

      // If we don't want to show less than 4 stars then stop here
      if (showMorningstarAll === false && response.data.mstarRatOverall < 4) {
        return;
      }

      // Load the fund data
      setFundData(response.data);
    } catch (e) {
      console.log(e);
    }
  };

  // Set up the showInfo value
  const toggleInfoModal = () => {
    setShowInfo(!showInfo);
  };
  const locale = wtRegion in LOCALE_LOOKUP ? LOCALE_LOOKUP[wtRegion] : 'en-US';

  /*********************/
  // RENDER METHODS
  /*********************/
  const renderTitle = function () {
    let showIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-title"
    }, _i18n.default.t('overall-mstar-rating'), " ", showIcon ? /*#__PURE__*/_react.default.createElement("div", {
      className: "info-icon",
      onClick: toggleInfoModal
    }, /*#__PURE__*/_react.default.createElement("sup", null, "i")) : null);
  };
  const renderStars = numStars => {
    // Check if we have N/A
    if (numStars === NA) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mstar-stars"
      }, NA);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-stars"
    }, [...Array(numStars)].map((item, index) => /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "fa",
      icon: "star",
      key: index
    })));
  };
  const renderOverallStars = function () {
    let explainStars = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-overall-stars"
    }, renderStars(fundData.mstarRatOverall), explainStars ? /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body-bold"
    }, fundData.mstarRatOverall.toLocaleString(locale), " ", _i18n.default.t('out-of-5-stars')) : null);
  };
  const renderDisclosure = () => {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body-text"
    }, _i18n.default.t('mstar-disclosure')), /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body-text"
    }, _i18n.default.t('mstar-disclosure-2')), showMorningstarAll === false ? /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body-text"
    }, _i18n.default.t('mstar-overall-less-stars')) : null);
  };
  const renderHistory = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-history"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-title"
    }, _i18n.default.t('history')), /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-history-list"
    }, [['03', 3], ['05', 5], ['10', 10]].map(year => {
      let numStars = fundData["mstarRatYrs".concat(year[0])];
      let fundCategory = /*#__PURE__*/_react.default.createElement("div", {
        className: "mstar-history-text"
      }, fundData.morningStarCategory, " (", fundData["numberOfInvestmentsYrs".concat(year[0])].toLocaleString(locale), " ", _i18n.default.t('funds'), ")");
      // If the value is null then set 'N/A'
      if (!numStars) {
        numStars = NA;
        fundCategory = null;
      }

      // Render the history details using the number of stars
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mstar-history-period",
        key: year[0]
      }, renderStars(numStars), /*#__PURE__*/_react.default.createElement("div", {
        className: "mstar-history-text"
      }, "".concat(year[1], "-").concat(_i18n.default.t('year'), " | ").concat(numStars, " ").concat(numStars !== NA ? _i18n.default.t('out-of-5-stars') : '')), fundCategory);
    })));
  };
  const renderModal = () => {
    return /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
      open: showInfo === true,
      onClose: toggleInfoModal,
      showCloseIcon: true,
      focusTrapped: false,
      classNames: {
        overlay: 'modal-overlay',
        modal: 'mstar-modal'
      },
      closeOnOverlayClick: true // Stops user from closing when clicking off modal
      ,
      closeOnEsc: true,
      center: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-modal-container"
    }, renderTitle(false), renderOverallStars(true), renderDisclosure(), renderHistory(), /*#__PURE__*/_react.default.createElement("div", null, _i18n.default.t('mstar-based-on')), /*#__PURE__*/_react.default.createElement("div", null, _i18n.default.t('past-performance'))));
  };

  // Render the main body of the widget that lives on the page
  const renderWidget = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body"
    }, renderTitle(), renderModal(), renderOverallStars(), /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body-text"
    }, fundData.morningStarCategory, " (", fundData.numberOfInvestmentsOverall.toLocaleString(locale), " ", _i18n.default.t('funds'), ")"), /*#__PURE__*/_react.default.createElement("div", {
      className: "mstar-body-text"
    }, _i18n.default.t('as of'), " ", (0, _functions.formatLongDate)(fundData.date, locale), " | ", _i18n.default.t('based-on-risk-adjusted')));
  };
  return fundData ? /*#__PURE__*/_react.default.createElement("div", {
    className: "mstar-widget"
  }, renderWidget()) : null;
}

// Set default props
MorningstarWidget.defaultProps = {
  dataspanApiUrl: "https://dataspanapidev.wisdomtree.com",
  ticker: "DLN",
  wtDivisionID: 1,
  wtRegion: "US",
  showMorningstarAll: false
};
MorningstarWidget.propTypes = {
  dataspanApiUrl: _propTypes.default.string.isRequired,
  ticker: _propTypes.default.string.isRequired,
  wtDivisionID: _propTypes.default.number.isRequired,
  wtRegion: _propTypes.default.string.isRequired,
  showMorningstarAll: _propTypes.default.bool.isRequired
};
var _default = exports.default = MorningstarWidget;